module.exports = __webpack_public_path__ + "img/Logo_Trattoria_Benati_bg_black.6d1ca152.jpg";